import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useLayoutEffect, useRef } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import withProductAddons from "areas/product/hoc/with-product-addons"
import { addToCart, setFixedATC } from "areas/product/store/actions"
import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"
import useWindowDimensions from "helpers/window-dimensions"

import { ActionButton } from "./components"

const Wrapper = styled(Box)`
  ${(props) =>
    props.fixedATC
      ? `
      background: ${props.theme.colors.white};
      box-shadow: 0 -4px 4px 0 rgba(0, 0, 0, 0.15);
      bottom: 0;
      left: 0;
      padding: 16px;
      position: fixed;
      width: 100%;
      z-index: 2;
      ${props.theme.mediaQueries.tablet`
        box-shadow: none;
        padding: 0;
        position: static;
        width: auto;
      `}
    `
      : `
      margin-bottom: 20px;
    `}
`

const InternalAddToCartButton = ({
  addToCart,
  fixedATC,
  header,
  isAddingToCart,
  lid,
  setFixedATC,
  totalItemPrice,
  wizardRef,
}) => {
  const { isMobile } = useWindowDimensions()
  const cancelled = useRef(false)

  const cartStr = jewlr_t("Cart")

  useLayoutEffect(() => {
    const addToCartScrollTick = () => {
      if (!cancelled.current) {
        if (isMobile) {
          window.requestAnimationFrame(() => {
            if (wizardRef.current) {
              const rect = wizardRef.current.getBoundingClientRect()
              if (!rect) return

              const fixed =
                rect.bottom <= 0 || rect.bottom >= window.innerHeight
              setFixedATC(fixed)
            }
          })
        } else {
          setFixedATC(false)
        }
      }
    }

    addToCartScrollTick()
    window.addEventListener("scroll", addToCartScrollTick, false)

    return () =>
      window.removeEventListener("scroll", addToCartScrollTick, false)
  }, [isMobile, wizardRef.current])

  useEffect(() => {
    return () => (cancelled.current = true)
  }, [])

  return (
    <Wrapper fixedATC={fixedATC}>
      <ActionButton
        className="js-add-cart"
        data-cy="product-wizard-add-to-cart-btn"
        disabled={isAddingToCart}
        fontWeight={{ _: 600, desktop: 300 }}
        loading={isAddingToCart}
        onClick={(e) => addToCart(e, isAddingToCart)}
        primary
        rel="nofollow"
        type="submit"
      >
        {isMobile && <>{to_currency(totalItemPrice)} &ndash; </>}
        {header.params_olid_present
          ? "Update Order"
          : lid
          ? isAddingToCart
            ? `Updating ${cartStr}...`
            : `Update ${cartStr}`
          : isAddingToCart
          ? `Adding to ${cartStr}...`
          : `Add to ${cartStr}`}
      </ActionButton>
    </Wrapper>
  )
}

InternalAddToCartButton.propTypes = {
  addToCart: PropTypes.func,
  fixedATC: PropTypes.bool,
  header: PropTypes.object,
  isAddingToCart: PropTypes.bool,
  lid: PropTypes.string,
  setFixedATC: PropTypes.func,
  totalItemPrice: PropTypes.number,
  wizardRef: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    fixedATC: state.wizardUI.fixedATC,
    header: state.wizard.header,
    isAddingToCart: state.wizardUI.isAddingToCart,
    lid: state.wizardUI.lid,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (e, isAddingToCart) => {
      e.preventDefault()
      if (!isAddingToCart) {
        dispatch(addToCart())
      }
    },
    setFixedATC: (fixed) => dispatch(setFixedATC(fixed)),
  }
}

const AddToCartButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalAddToCartButton)

export default withProductAddons(AddToCartButton)
